import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { Simulation } from '../models/creneaux/creneau';


const resource = 'simulations'

export default class SimulationsResource {
  public async paginatedList(search?: string, pagenumber?: number, pagesize?: number) : Promise<PaginatedList<Simulation>> {
    const params = new URLSearchParams();
    if (search) params.append('Search', search.toString());
    if (pagenumber) params.append('PageNumber', pagenumber.toString());
    if (pagesize) params.append('PageSize', pagesize.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }

  public async getById(id: string) : Promise<Simulation> {
    const params = new URLSearchParams();

    const response = await api.get(`${resource}/${id}`, { params: params })
    return response.data
  }

  public async post(data: Simulation) : Promise<Simulation> {
    const response = await api.post(`${resource}`, data)
    return response.data
  }

  public async update(id: string, data : Simulation) : Promise<Simulation> {
    const response = await api.put(`${resource}/${id}`, data)
    return response.data
  }

  public async validate(id: string) : Promise<Simulation> {
    const response = await api.put(`${resource}/${id}/validate`)
    return response.data
  }

  public async delete(id : string) : Promise<Simulation> {
    const response = await api.delete(`${resource}/${id}`)
    return response.data
  }
}
